<ng-container *ngFor="let variant of variants">
  <ui-radio-item class="d-block mb-3"
                 [checked]="variant.id === activeVariant?.id"
                 [value]="variant"
                 (onClick)="activeVariant=$event; onSelect.emit($event)">
     <span>
      {{variant.name}}
       <span *ngIf="variant.priceDiff > 0 && !disabled && !isPieces">
        + {{variant.priceDiff | tryToDiscountPrice: discount: currency}}
      </span>
      <span *ngIf="!disabled && isPieces"> - {{variant.price | tryToDiscountPrice: discount: currency}}</span>
      <span *ngIf="variant.mostPopular"
            class="ps-2 text-primary">
        (<span [translate]="'cakeBuilder.cakeVariantsSection.mostPopular'"></span>)
      </span>
      </span>
  </ui-radio-item>
</ng-container>

